import React from 'react';
import ErrorPage from '../ErrorPage';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error,
            errorInfo,
        });
    }

    render() {
        const { main } = this.props;
        const { errorInfo } = this.state;

        if (errorInfo) {
            // Error path
            return (
                <ErrorPage
                    isFullPage={main}
                    showReloadButton={true}
                    showBackButton={false}
                    data-testid="error-boundary.error-page"
                />
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}

export default ErrorBoundary;
